<template>
 <div class="block-format d-flex flex-wrap">
    <div class="block-format__format-btn mr-4 mt-2 px-2 d-flex align-items-center justify-content-center" v-for="format in formatButtons"
      :key="format.name" @click="selectFormat(format)"
      :class="{selected: selectedFormat.name === format.name}">
      {{format.name}}
    </div>
    <div class="block-format__format-input mt-2 d-flex align-items-center" v-if="isFormatInputEnable">
      <input placeholder="ширина" type="text" autocomplete="off" class="form-control" v-model="inputWidthValue">
      <span class="mx-1">x</span>
      <input placeholder="высота" type="text" autocomplete="off" class="form-control" v-model="inputHeightValue">
    </div>
  </div>
</template>
<script>

const getDefaultFormat = () => {
  return {
    name: '',
    width: null,
    height: null
  }
}

export default {
  name: 'CalculatePriceBlockFormat',
  components: {},
  props: {
    data: {
      default: () => {
        return []
      }
    }
  },
  data: () => {
    return {
      selectedFormat: getDefaultFormat(),
      inputWidthValue: null,
      inputHeightValue: null
    }
  },
  methods: {
    selectFormat (format) {
      if (format.name === this.selectedFormat.name) {
        this.selectedFormat = getDefaultFormat()
        this.$emit('updateSelection', undefined)
      } else {
        this.inputWidthValue = null
        this.inputHeightValue = null
        this.selectedFormat = Object.assign({}, format)
        const selectedFormat = { width: this.selectedFormat.width, height: this.selectedFormat.height }
        this.$emit('updateSelection', selectedFormat)
      }
    }
  },
  computed: {
    formatButtons () {
      return this.data.filter(x => !!x.name)
    },
    isFormatInputEnable () {
      return this.data.some(x => !x.name)
    }
  },
  watch: {
    inputWidthValue: function (newValue) {
      let selectedFormat = {}
      if (newValue) {
        if (this.selectedFormat.name) {
          this.selectedFormat.name = ''
          this.selectedFormat.height = null
        }

        this.selectedFormat.width = newValue
        selectedFormat = { width: this.selectedFormat.width, height: this.selectedFormat.height }
      }

      if (!this.selectedFormat.width && !this.selectedFormat.height) {
        this.$emit('updateSelection', undefined)
      } else if (newValue !== null) {
        this.$emit('updateSelection', selectedFormat)
      }
    },
    inputHeightValue: function (newValue) {
      let selectedFormat = {}
      if (newValue) {
        if (this.selectedFormat.name) {
          this.selectedFormat.name = ''
          this.selectedFormat.width = null
        }

        this.selectedFormat.height = newValue
        selectedFormat = { width: this.selectedFormat.width, height: this.selectedFormat.height }
      }

      if (!this.selectedFormat.width && !this.selectedFormat.height) {
        this.$emit('updateSelection', undefined)
      } else if (newValue !== null) {
        this.$emit('updateSelection', selectedFormat)
      }
    }
  },
  created () {
    const selectedFormat = null
    this.$emit('updateSelection', selectedFormat)
  }
}
</script>

<style lang="scss" scoped>
.block-format {
  &__format-btn {
    cursor: pointer;
    position: relative;
    height: 38px;
    min-width: 80px;
    border-radius: 4px;
    box-shadow: inset 0 1px 0 rgba(40, 189, 139, 0.15);
    background-color: #e9f8f3;
    color: #28bd8b;
    max-width: 400px;

    &.selected {
      background-color: #28bd8b;
      color: #fff;
    }
  }

  &__format-input {
    max-width: 200px;
  }
}
</style>
